module.exports = require('date-fns/isSameMonth').isSameMonth;
